module.exports = __webpack_public_path__ + "img/24.aabd0289.webp";